<template>
  <div class="failnum">
    <Table
      @on-sort-change="changesort"
      @on-selection-change="selectChange"
      stripe
      :columns="columns"
      :data="data"
    ></Table>
    <div class="page-div">
      <div class="page-div-left page-div-lefts">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Button class="title-btn fourSize" type="success" ghost @click="reupload"
        >重传</Button
      >
      <Page
        :total="obj.total"
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>
    <div style="clear:both;"></div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <Modal
      class="ivumodal"
      width="500"
      footer-hide
      v-model="errors"
      title="确认操作"
    >
      <div class="ivumodal-cont">
        请选择需要操作的数据。
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(1)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import {
        selectUploadFailPatientListt,
        reuploadFailPatient,
        selectUploadSuccessPatientList
    } from "../servers/api";
    export default {
        props: {
            idOrgReservation: String
        },
        data() {
            return {
                errors: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                isiconfontshow: false,
                columns: [{
                    type: "selection",
                    width: 50,
                    align: "center"
                }, {
                    title: "姓名",
                    width: 85,
                    key: "patientName",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "性别",
                    width: 85,
                    key: "sex",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "年龄",
                    width: 85,
                    key: "age",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "套餐名称",
                    width: 211,
                    key: "examSuiteAlias",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "修改状态",
                    width: 110,
                    key: "phone",
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        // 1chong
                        let item = "";
                        if (params.row.reuploadStatus == 1) {
                            item = "可重传";
                        } else {
                            item = "不可重传";
                        }
                        return h("div", [h("span", {}, item)]);
                    }
                }, {
                    title: "上传日期",
                    width: 110,
                    ellipsis: true,
                    sortable: true,
                    key: "idCardNo",
                    align: "center",
                    render: (h, params) => {
                        let item = "";
                        if (params.row.createTime) {
                            item = params.row.createTime.slice(0, 11);
                        }
                        return h("div", [h("span", {}, item)]);
                    }
                }, {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 80,
                    render: (h, params) => {
                        let a = "#eee";
                        let b = "";
                        if (params.row.reuploadStatus == 1) {
                            a = "#7F7F7F";
                            b = "#53CAC3";
                        } else {
                            a = "rgb(191,191,212)";
                            b = "rgb(191,191,212)";
                        }
                        return h(
                            "div", {
                                style: {
                                    height: "28px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    border: "1px solid #53CAC3",
                                    "border-radius": "5px",
                                    width: "50px",
                                    "margin-right": "12px",
                                    cursor: "pointer",
                                    disabled: false,
                                    color: a,
                                    "border-color": b
                                        // background:a
                                },
                                on: {
                                    click: () => {
                                        if (params.row.reuploadStatus == 1) {
                                            this.reuploadFailPatient(params.row.idPatient);
                                        }
                                    }
                                }
                            },
                            "重传"
                        );
                    }
                }],
                data: [],
                current: 1,
                pageSize: 20,
                selectNum: 0,
                selectList: [],
                orderField: "",
                isAsc: "",
                obj: {}
            };
        },
        methods: {
            ok() {
                this.errors = false;
            },
            reupload() {
                //上传
                if (this.selectList.length == 0) {
                    this.errors = true;
                    return;
                }
                let list = [];
                for (let i = 0; i < this.selectList.length; i++) {
                    list.push(this.selectList[i].idPatient);
                }
                this.reuploadFailPatient(list.join(","));
            },
            reuploadFailPatient(item) {
                //上传接口
                this.isiconfontshow = true;
                let params = {
                    idPatientList: item,
                    idOrgReservation: this.idOrgReservation
                };
                reuploadFailPatient(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.selectList = [];
                        this.selectNum = this.selectList.length;
                        this.alertTitleIshow = true;
                        this.selectUploadFailPatientList();
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            pagenum(num) {
                //父组件接参
                this.current = 1;
            },
            selectUploadFailPatientList(id) {
                //失败人员列表
                this.isiconfontshow = true;
                let params = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    idOrgReservation: id || this.idOrgReservation,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                selectUploadSuccessPatientList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data;
                        this.data = res.data.data.list || [];
                    }
                });
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.current = 1;
                this.selectList = [];
                this.selectNum = this.selectList.length;
                this.selectUploadFailPatientList();
            },
            selectChange(item) {
                //多选
                this.selectList = item;
                this.selectNum = this.selectList.length;
            },
            changePeoplecurrent(num) {
                //换页
                this.selectList = [];
                this.selectNum = this.selectList.length;
                this.current = num;
                this.selectUploadFailPatientList();
            },
            changepeoplepage(num) {
                //换条数
                this.pageSize = num;
                this.current = 1;
                this.selectList = [];
                this.selectNum = this.selectList.length;
                this.selectUploadFailPatientList();
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .page-div {
        width: 100%;
        margin-top: 15px;
        .page-div-left {
            float: left;
            padding: 5px 10px;
        }
        .page-div-lefts {
            border-right: 1px solid #d7d7d7;
            margin-right: 15px;
        }
        .page-div-page {
            float: right;
            margin-right: 15px;
        }
    }
    
    .failnum {
        max-height: 500px;
        overflow: hidden;
        overflow-y: visible;
    }
</style>


// WEBPACK FOOTER //
// src/components/tan/sucusse.vue